import { getEnumValues } from '../enums';

export enum Group{
	EventAdmins='event-admins',
}

export const GroupValues = getEnumValues<Group>(Group);